import React from 'react';
import Offer from './offer';
import OfferV4 from './offerV4/offerV4';
import OfferV5 from './offerV5/offerV5';
import OfferV6 from './offerV6/offerV6';
import OfferV7 from './offerV7/offerV7';

interface Props {
  currentProduct: string | null;
  discount?: boolean;
  secondScreenWrapper?: boolean;
  tariff?: string;
}

/** Picks the offer design for the current tariff group. */
export const PaymentOffer = React.memo<Props>(
  function PaymentOffer({ currentProduct, secondScreenWrapper, tariff }) {
    if (tariff === 'v001' || tariff === 'v002' || tariff === 'v003') {
      return <OfferV7 currentProduct={currentProduct} secondScreenWrapper={secondScreenWrapper} />;
    }

    if (tariff === 'v48') {
      return <OfferV6 currentProduct={currentProduct} secondScreenWrapper={secondScreenWrapper} />;
    }

    if (tariff === 'v45' || tariff === 'v46') {
      return <OfferV5 currentProduct={currentProduct} secondScreenWrapper={secondScreenWrapper} />;
    }

    if (tariff === 'v43' || tariff === 'v44') {
      return <OfferV4 currentProduct={currentProduct} secondScreenWrapper={secondScreenWrapper} />;
    }

    return <Offer currentProduct={currentProduct} secondScreenWrapper={secondScreenWrapper} />;
  },
  (prevProps, nextProps) => {
    return (
      prevProps.discount === nextProps.discount &&
      prevProps.currentProduct === nextProps.currentProduct &&
      prevProps.tariff === nextProps.tariff &&
      prevProps.secondScreenWrapper === nextProps.secondScreenWrapper
    );
  }
);
